import React from 'react';
import Spacer from 'components/Spacer';
import { Heading } from 'components/Typography';
import { useCard } from '../CardContext';
import * as S from './styles';
import { CardHeaderProps } from './types';

/**
 * Wraps elements passed to the Card's `header` prop to provide layout for the
 * Card's header.
 */
export const CardHeader: React.FC<CardHeaderProps> = ({
  actionButton,
  className,
  icon,
  subtitle,
  title,
}) => {
  const { fullScreen } = useCard();

  return (
    <S.Root className={className} fullScreen={fullScreen}>
      {icon && (
        <S.IconContainer>
          <S.Icon>{icon}</S.Icon>
        </S.IconContainer>
      )}
      {actionButton && <S.Action>{actionButton}</S.Action>}
      <Spacer align="center" orientation="vertical" space="13px">
        {typeof title === 'string' ? (
          <Heading level={1}>{title}</Heading>
        ) : (
          title ?? null
        )}
        {typeof subtitle === 'string' ? (
          <Heading level={2}>{subtitle}</Heading>
        ) : (
          subtitle ?? null
        )}
      </Spacer>
    </S.Root>
  );
};

export default CardHeader;
